import { useState, useEffect } from "react";
import { Separator } from "@/components/ui/separator";
import { CreditCard } from "lucide-react";
import { supabase } from "@/lib/supabase";
import { SubscriptionPlans } from "./sections/token-management/SubscriptionPlans";
import { EmailSection } from "./sections/account/EmailSection";
import { PasswordSection } from "./sections/account/PasswordSection";
import { AccountHeader } from "./sections/account/AccountHeader";

const AccountSettings = () => {
  const [email, setEmail] = useState("");

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        console.log('Retrieved user email:', user.email);
        setEmail(user.email || "");
      }
    };
    
    getUser();
  }, []);

  return (
    <div className="space-y-8">
      <AccountHeader />
      <EmailSection email={email} />
      <PasswordSection />
      <Separator className="my-6" />
      <div>
        <h2 className="text-2xl font-bold mb-6 flex items-center gap-2">
          <CreditCard className="h-6 w-6" />
          Subscription Plans
        </h2>
        <SubscriptionPlans />
      </div>
    </div>
  );
};

export default AccountSettings;